recSliderInit();
function recSliderInit() {
  let recomendationsSlider;
  recomendationsSlider = new Flickity(".recommendations-carousel", {
    selectedAttraction: 0.12,
    friction: 0.9,
    imagesLoaded: true,
    groupCells: "100%",
    cellAlign: "left",
    prevNextButtons: true,
    wrapAround: false,
    pageDots: false,
    resize: true,
  });
  recomendationsSlider.resize();
}

 
